import { Container, Graphics, Text } from 'pixi.js';
import type { SolverHistory } from './types';
import { SolverVisualisationStepView } from './SolverVisualisationStepView';

export class SolverHistoryView extends Container {
  private currentStep = 0;

  private stepView: SolverVisualisationStepView | null = null;

  constructor(private readonly history: SolverHistory) {
    super();
    this.init();
  }

  private init(): void {
    this.addBackground();
    this.createNavigationBar();
    this.setStep(0);
  }

  private addBackground(): void {
    const gfx = new Graphics();
    gfx.rect(0, 0, 4000, 4000);
    gfx.fill(0x878787);
    gfx.eventMode = 'static';
    gfx.props({ parent: this });
  }

  private setStep(index: number): void {
    const step = this.history.steps[index];
    if (!step) return;

    this.currentStep = index;

    this.stepView?.destroy({ children: true });
    this.stepView = new SolverVisualisationStepView(step).props({
      parent: this,
    });
  }

  private createNavigationBar(): void {
    const navigationContainer = new Container().props({
      parent: this,
      x: 100,
      y: 1200,
    });

    this.addButton('NEXT', () => {
      this.setStep(this.currentStep + 1);
    }).props({
      parent: navigationContainer,
    });

    this.addButton('PREV', () => {
      this.setStep(this.currentStep - 1);
    }).props({
      parent: navigationContainer,
      x: 200,
    });

    this.addButton('PERF', () => {
      this.stepView?.animateMove();
    }).props({
      parent: navigationContainer,
      x: 500,
    });

    this.addButton('CLOSE', () => {
      this.destroy({ children: true });
    }).props({
      parent: navigationContainer,
      x: 1000,
    });
  }

  private addButton(label: string, callback: () => void): Text {
    const button = new Text(label, {
      fontSize: 40,
      fill: 'black',
    });
    button.eventMode = 'static';
    button.on('pointertap', callback);
    return button;
  }
}
